import { Card } from "../components/Card";
import { AttentionList, DashKpis, DashProgress, NaruCards, ProjectCards, dashFacts, naruRows } from "../components/Dash";
import type { RunnerRow } from "../lib/auth";
import { ISSUES, MOCK_NOW } from "../mock/issues";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 대시보드의 부품 ══
   견본 목록(mock/issues)을 대시보드와 **같은 함수**(dashFacts · naruRows)로 접어 상태마다 세운다. 서버를 안 부른다. */

const ago = (min: number) => new Date(MOCK_NOW - min * 60_000).toISOString();
const RUNNERS: RunnerRow[] = [
  { name: "naru-1", source: "web", createdBy: "o2hp", createdAt: null, connections: 1, lastSeenAt: ago(1),
    presence: { name: "naru-1", runner: "naru-1", tags: [], vendors: ["claude"], version: "0.9", mode: "host", since: ago(90) } },
  { name: "naru-2", source: "web", createdBy: "o2hp", createdAt: null, connections: 1, lastSeenAt: ago(1),
    presence: { name: "naru-2", runner: "naru-2", tags: [], vendors: ["claude"], version: "0.9", mode: "host", since: ago(300) } },
  { name: "naru-3", source: "env", createdBy: null, createdAt: null, connections: 0, presence: null, lastSeenAt: ago(800), downSince: ago(800) },
  { name: "naru-4", source: "web", createdBy: "o2hp", createdAt: null, connections: 0, presence: null, lastSeenAt: null },
];

export function DashStates() {
  const f = dashFacts(ISSUES);
  const noop = () => undefined;
  return (
    <>
      <h3>{tx("pat.dash.kpi")}</h3>
      <Card>
        <DashKpis k={f.kpi} />
      </Card>
      <h3>{tx("pat.dash.naru")}</h3>
      <div className="pat__grid">
        <Card title="admin">
          <NaruCards rows={naruRows(RUNNERS, ISSUES)} now={MOCK_NOW} />
        </Card>
        <Card title="sessions only">
          <NaruCards rows={naruRows(null, ISSUES)} now={MOCK_NOW} note={tx("dashx.naru.adminOnly")} />
        </Card>
        <Card title="empty">
          <NaruCards rows={[]} now={MOCK_NOW} />
        </Card>
      </div>
      <h3>{tx("pat.dash.progress")}</h3>
      <div className="pat__grid">
        <Card title="value">
          <DashProgress done={f.done} total={f.total} />
        </Card>
        <Card title="empty">
          <DashProgress done={0} total={0} />
        </Card>
      </div>
      <h3>{tx("pat.dash.attention")}</h3>
      <div className="pat__grid">
        <Card title="rows">
          <AttentionList rows={f.attention} onOpen={noop} now={MOCK_NOW} />
        </Card>
        <Card title="empty">
          <AttentionList rows={[]} onOpen={noop} now={MOCK_NOW} />
        </Card>
      </div>
      <h3>{tx("pat.dash.projects")}</h3>
      <ProjectCards projects={f.projects} names={{}} onOpen={noop} />
      <Card title="empty">
        <ProjectCards projects={[]} names={{}} onOpen={noop} />
      </Card>
    </>
  );
}
